"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sizes = void 0;
exports.Sizes = {
    tickLineWidth: 1,
    tickLineHeight: 10,
    tickDotSize: 3,
};
//# sourceMappingURL=constants.js.map